__turbopack_context__.v({
  "pb-stripes-animate": "TaskWithProgressBar-module__AkLLYq__pb-stripes-animate",
  "pbAnimated": "TaskWithProgressBar-module__AkLLYq__pbAnimated",
  "pbContainer": "TaskWithProgressBar-module__AkLLYq__pbContainer",
  "pbFill": "TaskWithProgressBar-module__AkLLYq__pbFill",
  "pbRounded": "TaskWithProgressBar-module__AkLLYq__pbRounded",
  "pbStriped": "TaskWithProgressBar-module__AkLLYq__pbStriped",
});
